import api from '../lib/api';
import type { Assistant, AssistantType, Integration, AssistantFunction, AssistantModel } from '../types/assistant';
import type { TimeCondition } from '../types/timeCondition';

class AssistantService {
  async getAssistants(): Promise<Assistant[]> {
    const response = await api.get('/assistants');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async getAssistantTypes(): Promise<AssistantType[]> {
    const response = await api.get('/assistants/types');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async createAssistant(data: Partial<Assistant>): Promise<Assistant> {
    const response = await api.post('/assistants', data);
    return response.data;
  }

  async updateAssistant(id: number, data: Partial<Assistant>): Promise<Assistant> {
    const response = await api.put(`/assistants/${id}`, data);
    return response.data;
  }

  async deleteAssistant(id: number): Promise<void> {
    await api.delete(`/assistants/${id}`);
  }

  async getIntegrations(): Promise<Integration[]> {
    const response = await api.get('/integrations');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async getTimeConditions(): Promise<TimeCondition[]> {
    const response = await api.get('/assistants/time-conditions');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async getAssistantFunctions(): Promise<AssistantFunction[]> {
    const response = await api.get('/assistants/functions');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async getAssistantModels(): Promise<AssistantModel[]> {
    const response = await api.get('/assistant-models');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }
}

export default new AssistantService();
